import { render } from "./IconPickerComponent.vue?vue&type=template&id=4ee34770&scoped=true"
import script from "./IconPickerComponent.vue?vue&type=script&lang=js"
export * from "./IconPickerComponent.vue?vue&type=script&lang=js"

import "./IconPickerComponent.vue?vue&type=style&index=0&id=4ee34770&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ee34770"]])

export default __exports__